import { render, staticRenderFns } from "./BidItemComponent.vue?vue&type=template&id=5280ce94&"
import script from "./BidItemComponent.vue?vue&type=script&lang=js&"
export * from "./BidItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports